/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Shift
 */
export interface Shift {
    /**
     * 
     * @type {string}
     * @memberof Shift
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof Shift
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof Shift
     */
    updatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof Shift
     */
    label: string;
}

/**
 * Check if a given object implements the Shift interface.
 */
export function instanceOfShift(value: object): value is Shift {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    return true;
}

export function ShiftFromJSON(json: any): Shift {
    return ShiftFromJSONTyped(json, false);
}

export function ShiftFromJSONTyped(json: any, ignoreDiscriminator: boolean): Shift {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'label': json['label'],
    };
}

export function ShiftToJSON(json: any): Shift {
    return ShiftToJSONTyped(json, false);
}

export function ShiftToJSONTyped(value?: Shift | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'].toISOString(),
        'label': value['label'],
    };
}

